import React, { useState, useMemo } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import GamesTable from './Table';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { useIntl } from 'umi';
import { useCompanyOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useCompanyOptionList';

const ContriesShareCard = (props: any) => {
  const {
    chartType,
    setChartType,
    entityType,
    tableData = [],
    lineData,
    cardStatus,
    tableTotal,
    dateType,
    startDate,
    endDate,
    segmentList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    changeSegement,
    tabId,
    setChartLoading,
    chartLoading,
    regionsCountries,
    barOrPieList,
    gameName,
  } = props;
  const { digitalColumnsList } = useCompanyOptionList();

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [chartType, setChartType] = useState('bar');
  const [metricSegVal, setMetricSegVal] = useState(segmentList[0].value);
  const [metricSegValText, setMetricSegValText] = useState(segmentList[0].text);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_countries_share` })}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-editionsshare-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_countries_share` })}
        activeTab={chartType}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <Segment
          value={metricSegVal}
          onChange={(value) => {
            /**切换segement时，更新聚合数据，更新可视化数据 */
            setMetricSegVal(value);
            const metricObj = segmentList?.find((item: any) => item.value == value) || {};
            setMetricSegValText(metricObj?.text);
            if (changeSegement instanceof Function) {
              changeSegement(value);
            }
          }}
          options={segmentList}
        />
        <div className="editionsshare-card-line">
          <Visualis
            chartType={chartType}
            dateType={dateType}
            startDate={startDate}
            endDate={endDate}
            imageType={entityType}
            lineData={lineData}
            isNodata={isNoData}
            metric={metricSegVal}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            titleNow={metricSegValText}
            tableData={barOrPieList} //不要用tableData, 排序和分页表格数据会变
            gameName={gameName}
            regionsCountries={regionsCountries}
            segmentList={segmentList}
            tabId={tabId}
          />
        </div>
        {/* 表格头部加table-header-normal没有排序样式  table-header是排序样式*/}

        <GamesTable
          entityType={entityType}
          segementType={metricSegVal}
          tableLoading={tableLoading}
          tableTotal={tableTotal}
          tableData={tableData}
          dateType={dateType}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
          columnsList={digitalColumnsList.country[metricSegVal]}
        />
      </CardSlotV2>
    </div>
  );
};

export default ContriesShareCard;
